import {Col as RBCol, Row as RBRow} from "react-bootstrap"
import styled from "styled-components"

import {SpacingProps, spacingCss} from "../global/css"

export const Col = styled(RBCol)<SpacingProps>`
  ${spacingCss}
`

export const Row = styled(RBRow)<SpacingProps>`
  ${spacingCss}
`

export type {CardProps} from "./Card"
export {default as Card} from "./Card"
export {default as ShadowCard} from "./ShadowCard"
export {default as Section} from "./Section"
export {default as Hr} from "./Hr"
export {default as Banner} from "./Banner"
export {default as Dropzone} from "./Dropzone"
export {default as GridCentered} from "./GridCentered"
export type {GridProps} from "./GridCentered"
